import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 500;\n  margin-left: 10px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: none;\n  border-radius: 2px;\n  box-sizing: border-box;\n  color: ", ";\n  margin: 0.2em;\n  padding: 10px;\n  box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.24);\n  position: relative;\n\n  :disabled {\n    opacity: 0.24;\n  }\n\n  :enabled {\n    :focus {\n      outline: none;\n      box-shadow: 0 0.063em 0.063em 0 rgba(0, 0, 0, 0.12);\n    }\n\n    :active {\n      box-shadow: inset 0 0 0 2em rgba(0, 0, 0, 0.1);\n      box-shadow: 0 0.063em 0.063em 0 rgba(0, 0, 0, 0.12);\n    }\n\n    :hover,\n    :focus {\n      background-color: rgba(0, 0, 0, 0.04);\n      cursor: pointer;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import { mineShaft, white } from '../../styles/colors';
export var Container = styled.button(_templateObject(), white, mineShaft);
export var Text = styled.span(_templateObject2());